import { ClientOnly } from '@quirks/react'
import { Command as CommandPrimitive } from 'cmdk'
import { Circle, Search, X } from 'lucide-react'
import type React from 'react'
import { cn } from '@/src/utils/styles'
import { Spinner } from '../ui/spinner'
import { ShortcutDisplay } from './shortcut-display'

type SearchInputProps = {
  inputRef: React.RefObject<HTMLInputElement | null>
  isOpen: boolean
  isFetched: boolean
  onReset: () => void
  inputProps: React.ComponentPropsWithoutRef<typeof CommandPrimitive.Input>
} & React.HTMLAttributes<HTMLDivElement>

export const SearchInput = ({
  inputRef,
  isOpen,
  isFetched,
  onReset,
  inputProps,
  className,
  ...props
}: SearchInputProps) => (
  <div
    className={cn('flex items-center w-full text-primary', className)}
    cmdk-input-wrapper=''
    {...props}
  >
    <div
      className={cn(
        'mr-2 flex items-center align-center text-center',
        'text-secondary [&:has(+_input:focus)]:text-primary',
      )}
    >
      {inputProps.value && !isFetched ? (
        <Spinner className='text-accent-primary size-4 shrink-0' />
      ) : (
        <Search className='size-4 shrink-0' />
      )}
    </div>
    <CommandPrimitive.Input
      ref={inputRef}
      data-testid='global-search-input'
      className={cn(
        'flex h-12 w-full rounded-md bg-transparent py-3 text-base outline-none disabled:cursor-not-allowed disabled:opacity-50',
        'placeholder:text-secondary focus:placeholder:text-input-placeholder-focus',
      )}
      placeholder={
        isOpen ? 'Search tokens or contract address' : 'Search any token…'
      }
      {...inputProps}
    />
    {!isOpen ? (
      <div className='ml-2 hidden sm:block'>
        <ClientOnly>
          <ShortcutDisplay />
        </ClientOnly>
      </div>
    ) : (
      inputProps.value && (
        <div className='ml-2'>
          <div
            className='text-tertiary-100 px-2 py-1 relative'
            onMouseDown={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}
            onClick={onReset}
          >
            <Circle size={16} fill='currentColor' />
            <X
              size={12}
              className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 stroke-background stroke-[3]'
            />
          </div>
        </div>
      )
    )}
  </div>
)
